export default __webpack_public_path__ + "static/media/Webinar_Innovacion_febrero_final_n_.2b04aaa3.pdf";